import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconFilterClose: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M2.78571 4.48387L2.78571 13L4.21429 13L4.21429 4.48387H6L3.5 2L1 4.48387H2.78571Z"
        fill={fill}
      />
      <path d="M7 11H16V13H7V11Z" fill={fill} />
      <path d="M7 8H14V10H7V8Z" fill={fill} />
      <path d="M7 5H12V7H7V5Z" fill={fill} />
      <path d="M7 2H10V4H7V2Z" fill={fill} />
    </Icon>
  );
};

export default IconFilterClose;
